export default "__VITE_ASSET__e25992ab__"